import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class SearchService {

    private facilitiesUrl = `${environment.backendRoot}/webresources/frontend/entity.facilitygroup/`;
    private roomFacilitiesUrl = `${environment.backendRoot}/webresources/frontend/entity.roompropertygroup/`;
    private optionalCategoriessUrl = `${environment.backendRoot}/webresources/frontend/entity.optionalextracategory/`;
    private OptionalSubcategoriesUrl = `${environment.backendRoot}/webresources/frontend/entity.optionalextrasubcategory/`;
    private RequestUrl = `${environment.backendRoot}/webresources/frontend/entity.bookingrequest/createRequest/`;

    constructor(private http: HttpClient) { }

    getFacilities(): Observable<any> {
        return this.http.get(this.facilitiesUrl,
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
            }
        );
    }

    getRoomFacilities(): Observable<any> {
        return this.http.get(this.roomFacilitiesUrl,
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
            }
        );
    }

    getOptionalCategories(): Observable<any> {
        return this.http.get(this.optionalCategoriessUrl,
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
            }
        );
    }

    getOptionalSubcategories(): Observable<any> {
        return this.http.get(this.OptionalSubcategoriesUrl,
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
            }
        );
    }

    sendRequest(data) {
        const url = this.RequestUrl + encodeURIComponent(encodeURIComponent(JSON.stringify(data)));
        // console.log(decodeURIComponent(decodeURIComponent(url)));
        return this.http.get(url,
            {
                headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
            }
        );
    }
}
